var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaste(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 148.5 147.2",
    style: {
      enableBackground: "new 0 0 148.5 147.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.9,101.4l29-29.2l-0.1-8.2l0-3.1v0c-0.1-0.7-0.2-1.3-0.3-2c-0.5-2.6-1.5-5.1-2.9-7.5L52.6,33 c-2.1-3.5-1.6-8,1.1-11l3.4-3.6V0.4h-45l-0.8,17.2l4.3,5.3c2.3,2.8,2.6,6.9,0.7,10L3.1,55.6c-1.8,3.2-2.8,6.8-2.8,10.4v61 c0,5,3.9,9.2,8.8,9.6c1.2,0.4,2.5,0.6,3.8,0.5l43.6-0.7c1.2,0,2.3-0.2,3.4-0.5l-22-22.2C34.5,110.4,34.5,104.8,37.9,101.4z  M12.8,47l7-12c2.7-4.6,2.2-10.5-1.1-14.6l-3.3-4.1l0.5-11.8h37.2v12.3l-2.3,2.5C46.9,23.5,46.2,30,49.2,35l10.9,18.4 c0.3,0.5,0.5,0.9,0.8,1.4c-8.7,2.4-15.4-0.1-23-2.9C30.9,49.3,23.1,46.5,12.8,47z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "108.8,76.5 95.7,89.7 84.3,64.9 91.1,57.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "129.6,98.2 109.3,119.4 97.9,94.6 112.3,80.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131,54.1l-18.7,18.9L94.6,54.3L107.3,41c3-3.1,8-3.1,11,0L131,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.1,80l-14.1,14.6l-17.2-18.1l18.7-18.9l12.5,12.9C149.6,73.2,149.6,77.3,147.1,80z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.1,125l-21.3,21.4c-0.8,0.8-2.1,0.8-2.9,0L65.7,132l-22.9-23c-0.7-0.7-0.7-1.9,0-2.6L67,81.9L78.9,70 L104.1,125z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaste);
export default __webpack_public_path__ + "static/media/Taste.3a28235991ae5303dc45236d0bac9a1b.svg";
export { ForwardRef as ReactComponent };